
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account-closure",
      function () {
        return require("private-next-pages/account-closure/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account-closure"])
      });
    }
  